import { injectable } from 'tsyringe';
import { IDirectoryProviderToken } from '@bmai/shared';
import { IntegrationsPageViewModel } from './IntegrationsPageViewModel';
import { IntegrationsService, type ConnectionIngestionStatus } from './IntegrationsService';

@injectable()
export class IdentityProvidersPageViewModel extends IntegrationsPageViewModel {
    constructor(service: IntegrationsService) {
        super(service, IDirectoryProviderToken);
    }

    protected override fetchConnectionStatus(): Promise<ConnectionIngestionStatus[]> {
        return this.service.fetchDirectorySyncStatus();
    }
}
